/**
 * Utilities for persisting the login email so we can auto-validate it when the user returns from Login link
 */

const KEY = 'loginEmail';

export const saveLoginEmail = email => localStorage.setItem(KEY, email);
export const getLoginEmail = () => localStorage.getItem(KEY);
export const clearLoginEmail = () => localStorage.removeItem(KEY);
